import DicomUpload from './DicomUpload';

/**
 * Read off the COMPONENT, not passed as a prop: useWorkListToolbarActions.tsx:30
 * does `containerClassName: DicomUploadComponent?.containerClassName`. Cornerstone
 * does the same with Object.assign (miscCustomization.ts:6-8), which mutates its
 * own component in place; assigning to a named const here keeps ours immutable
 * from the outside.
 *
 * 'max-w-3xl' matches cornerstone's, and it must be a class tailwind-merge can win
 * with: DialogContent's base includes `max-w-md` and merges `className` after it
 * (platform/ui-next/src/components/Dialog/Dialog.tsx).
 */
Object.assign(DicomUpload, { containerClassName: 'max-w-3xl' });

export default DicomUpload;
